/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';

import { ToolbarOptions } from './toolbar-options';

@Component({
  standalone: false,
  selector: 'gh-root-toolbar',
  templateUrl: 'root-toolbar.component.html',
  styleUrls: ['root-toolbar.component.scss'],
})
export class RootToolbarComponent {
  @Input() loading: boolean = false;
  @Input() options?: ToolbarOptions;
}
